"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECL_TEMPLATES = void 0;
exports.ECL_TEMPLATES = {
    'Module 1: Introducing the Project & Finding Your Core Values': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                { text: 'Introduce concept of a capstone project and its significance in the US college application process' },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Identify core values, interests, and passions' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [{ text: 'Analyze hook statement' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [{ text: 'Brainstorm or expand on potential capstone project ideas' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 5,
            children: [{ text: 'Define project goals' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Discussed concept of Capstone Project with student: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "a capstone project is a culmination of your academic journey, where you'll apply your skills, knowledge, and expertise to tackle a real-world challenge. It's not merely an academic exercise; rather, it's an opportunity to address issues you're passionate about, leaving a lasting impact on your community.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Discussed the student’s hook statement:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Understanding Core Values: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Discussed with the student their passions, interests, and values.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Analysing the hook statement: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "Reviewed the student's hook statement together. Discussed each element. Helped them identify the key themes and activities mentioned in the hook statement that can be integrated into a capstone project.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            indent: 1,
            children: [
                {
                    text: 'Key theme 1',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [
                {
                    text: 'Theme in your hook statement:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [
                {
                    text: 'How you will Integrate theme into the capstone: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Brainstorming Capstone Project Ideas: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Guided student through a brainstorming session for potential capstone project ideas or how to scale an existing capstone project idea.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Defining Project Goals: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Assisted the student in defining clear goals for their capstone project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            indent: 1,
            children: [
                {
                    text: 'Goal 1',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [{ text: '' }],
        },
        {
            type: 'p',
            indent: 1,
            children: [
                {
                    text: 'Goal 2',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [{ text: '' }],
        },
        {
            type: 'p',
            indent: 1,
            children: [
                {
                    text: 'Goal 3',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [{ text: '' }],
        },
    ],
    'Module 2: Research': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Discuss the role of research in capstone project ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Learn to conduct research ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [{ text: 'Identify resources' }],
        },
        { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: 'Mentors/advisors' }] },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [{ text: 'Community engagement ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [{ text: 'Expert interviews ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [{ text: 'Discuss how to adapt project based on research findings' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Discussed the significance of research in validating the capstone project’s potential impact, identifying key challenges, and refining the project plan. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Discussed that successful capstone projects are built on a foundation of well-informed decisions',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Guided the student through the research process, covering the following areas:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Literature Review: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Encouraged the student to conduct an informal literature review related to their capstone project idea: they should seek to understand existing projects and initiatives to spark ideas or understand the competitive landscape. This involves gathering information from academic journals, books, articles, and credible online sources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Identifying Resources: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Examples of resources that can be used:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Google Scholar',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Harvard or other accredited University papers',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 3,
            children: [
                {
                    text: 'Primary research resources  (interviews, surveys, etc with professionals in their field or extremely relevant people to the topic)',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Feasibility Assessment: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Discussed potential challenges, risks, and obstacles that the student may encounter. Discussed mitigation strategies.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Mentors & Advisors: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Seek guidance from mentors or experts in the field.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Person 1',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 3,
            children: [
                {
                    text: 'Who are they?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 3,
            children: [
                {
                    text: 'How will you contact them?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 3,
            children: [
                {
                    text: 'What will you say?',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Community Engagement: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "Encouraged the student to engage with online forums, social media groups, and communities related to their project's theme.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Expert Interviews: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Discussed the potential of conducting interviews with experts in the field.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 3: Project Proposal & KPIs': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Complete a project proposal that pitches capstone idea ' }],
        },
        { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: 'Objectives' }] },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [{ text: 'Methodology & Execution ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [{ text: 'Community Impact ' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Define 3-5 Key Performance Indicators (KPIs) for capstone project ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [{ text: 'Implement a process for tracking and analyzing KPIs ' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Discussed the transformative power of a meticulously crafted project proposal in shaping the trajectory of a capstone project and impressing college admissions officers.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: "A well-crafted proposal is akin to a strategic roadmap that not only guides the project's execution but also",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: "conveys the student's aspirations, leadership, and potential for driving positive change.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Structuring the Project Proposal: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: " Now that we understand the significance of a compelling project proposal, let's dive into the practical steps of crafting one",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: "→ Link to Student's Project Proposal →",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Project Introduction: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Worked with the student to create a captivating and engaging introduction for the proposal. Discussed the use of storytelling techniques, real-life anecdotes, or intriguing questions to draw readers in. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Clear Objectives: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Ensured that the goals are specific, measurable, achievable, relevant, and time-bound (SMART). Discuss how the student will measure the success of each goal and the metrics they will use.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: "Link to Student's SMART Goals worksheet →",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Methodology and Execution: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Helped the student outline the step-by-step methodology for executing the project. Encouraged them to use tools like Microsoft Excel or Google Sheets to create a Gantt chart or project timeline. Discussed the importance of breaking down tasks and setting specific deadlines using project management platforms like Trello or Asana.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Community Impact: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "Assisted the student in describing the potential impact of the project on their community. Encouraged them to use concrete examples, statistics, or testimonials to demonstrate the project's significance. Used platforms like Canva or Piktochart to create infographics that visually represent the project's anticipated outcomes.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Alignment with Core Values: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Guided the student in highlighting how the project aligns with their core values and hook statement',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Review and Feedback: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Encouraged the student to exchange proposals with peers and provide constructive feedback. This collaborative approach can offer fresh insights and suggestions for improvement.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Expert Review:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "If possible, facilitate a review by professionals or experts in the project's field. Their expertise can provide valuable guidance on technical aspects and industry relevance.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Incorporate Feedback: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Guided the student in implementing the feedback received, ensuring that the proposal becomes more polished and aligned with its objectives.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 4: Action Plan': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Create a detailed action plan for execution of capstone project' }],
        },
        { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: 'Task breakdown' }] },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [{ text: 'Timeline and milestones' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [{ text: 'Resource allocation' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [{ text: 'Responsibilities and team collaboration' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Emphasized the ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'critical role of an action plan and project time management in steering the capstone project towards success. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: ' The action plan serves as a roadmap, ensuring that every step is carefully orchestrated',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Action Plans',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Facilitate systematic project execution ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'by breaking down the project into manageable tasks with clear deadlines and responsibilities.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Helps in ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'identifying potential challenges, allocating resources efficiently, and minimizing risks.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Enables ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'effective communication and collaboration ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'among team members if applicable.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Provide a ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'structured approach ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'to bring the project from inception to completion.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Creating an Action Plan: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Guided the student in creating a comprehensive action plan for their capstone project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'The plan should include the following elements: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Task Breakdown: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Helped the student break down the project into smaller, manageable tasks. Discussed the order of tasks, dependencies, and priority to create a logical sequence for project execution.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Techniques: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
                {
                    text: 'Use tools like Gantt charts or project management software to visualize the timeline and task dependencies.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Timeline and Milestones: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Worked with the student to establish a timeline for each task and identify key milestones. Ensured that the timeline aligns with the overall project timeline from the project proposal. Encouraged the student to allocate sufficient time for each phase of the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Techniques: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121))',
                },
                {
                    text: 'Set specific deadlines for each task and milestone to track progress effectively.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Resource Allocation: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Assisted the student in allocating resources such as time, funding, and support to each task. Discussed potential challenges and how to address them during project implementation.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Techniques: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
                {
                    text: 'Use a resource allocation matrix to identify the resources needed for each task and ensure they are readily available.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Responsibilities and Team Collaboration: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'If the project will involve a team or collaborators, discussed individual responsibilities and effective ways to facilitate teamwork and communication.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Techniques: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
                {
                    text: 'Set up regular team meetings and establish clear communication channels to ensure smooth collaboration.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(17, 61, 121)',
                },
            ],
        },
    ],
    'Module 5: Launching the Project': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Launching the capstone project' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [{ text: 'Project implementation strategy ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [{ text: 'Community engagement and impact ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [{ text: 'Project launch and post launch' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Create a plan for the project launch' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Discussed the significance of the "Launching" phase of the capstone project. Emphasized that this phase is all about turning plans into actions and bringing the project to life in the community.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Project Implementation Strategy:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Discussed project proposal and action plan.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Reviewed the specific steps outlined in the action plan.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: "Identified key milestones and metrics of success for the project's implementation.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Identified what are the immediate next steps are necessary for a minimum viable project (i.e. team, website)',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Recruiting Team Members ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Identifying Roles',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Assisted the student in identifying specific roles and skill sets needed for the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Effective Outreach',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Guided the student in reaching out to potential team members.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Team Dynamics',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Discussed strategies for fostering a collaborative and motivated team environment.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Community Engagement and Impact:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Discussed strategies for engaging the community and maximizing the impact of the capstone project. Encouraged the student to think creatively about how to involve others and make a meaningful difference',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Brainstormed ideas for involving community members, peers, or local organizations.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'This could be through creating a website or recruiting volunteers,',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Lesson Deliverable: Plan for the Project Launch (Fill this in):',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Timeline',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Tasks',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Launch overview',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Responsible parties',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 5,
            children: [
                {
                    text: 'Marketing & creating buzz',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 6,
            children: [
                {
                    text: 'Metrics of success to be measured 30 days from launch',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 6: Marketing and Promotion': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Develop effective marketing and promotional strategies for the capstone project' }],
        },
        { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: 'Defining target audience' }] },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [{ text: 'Crafting a compelling story ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [{ text: 'Marketing channels' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [{ text: 'Content creation' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 5,
            children: [{ text: 'Metrics and evaluation' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Create a marketing and promotion plan ' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: "Discussed the importance of effective marketing and promotion for the capstone project. Emphasized that this phase is about creating visibility, generating interest, and showcasing the project's value to the community and university admissions committees.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Defining Target Audience',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Guided the student in identifying or confirming their target audience for the project. Discussed who the project aims to benefit and who is likely to be interested in its outcomes.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Analyze the key stakeholders or beneficiaries of the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Consider the demographic, geographic, and psychographic characteristics of the target audience.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Crafting a Compelling Story',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: "Helped the student develop a compelling narrative that communicates the project's purpose, impact, and alignment with their hook statement.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Discussed the key elements of a persuasive story: problem, solution, impact, and personal connection.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Marketing Channels and Strategies',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Explored various marketing channels and strategies that the student can leverage to promote the capstone project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Discussed online channels such as social media, websites, and blogs.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Explored offline channels like presentations, workshops, and community events.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: "Encouraged the student to choose channels that align with their project's goals and target audience.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Content Creation',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Guided the student in creating engaging and impactful content to promote the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Discussed the types of content that can be used, such as videos, articles, infographics, and testimonials.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: "Brainstormed content ideas that highlight the project's achievements, community engagement, and leadership impact.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Metrics and Evaluation',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Introduced the concept of tracking and measuring the effectiveness of marketing efforts.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Guided the student in setting quantifiable goals for metrics like website visits, social media engagement, or event attendance.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            indent: 1,
            children: [
                {
                    text: 'Lesson Deliverable: Marketing and Promotion Plan (Fill this in)',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [
                {
                    text: 'Timeline',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Tasks',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Marketing strategy overview',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Defining target audience',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 5,
            children: [
                {
                    text: 'Compelling story',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 6,
            children: [
                {
                    text: 'Marketing channels',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 7,
            children: [
                {
                    text: 'Content creation',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 8,
            children: [
                {
                    text: 'Metrics and evaluation',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 7: KPI Tracking & Iteration': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Check in on the progress of your previously developed KPIs' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [{ text: 'Discuss challenges & progress' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Track data points' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [{ text: 'Redevelop KPIs if needed' }],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Discussed the importance of reviewing and ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'potentially redeveloping Key Performance Indicators (KPIs) ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "to ensure they accurately measure the project's progress and impact.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Explained that well-defined KPIs provide tangible metrics for evaluating progress and demonstrating achievements (and can be used in the 150 character description on the common app form). ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Review progress from existing KPIs: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Considered the original KPIs and SMART Goals developed in Module 3. Discussed the challenges or success the student has encountered in achieving the current KPIs.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Refining KPIs: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Iterated & Redeveloped KPIs to better reflect current progress of the capstone project. ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Pivoting: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Discussed strategies for pivoting the project in a different direction when a project is not meeting KPIs',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Explored backup options if the KPIs are too ambitious and unrealistic',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Rewrite & Redevelop KPIs: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Guided the student to update their KPIs based on whether the capstone project is on-track from the first iteration.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Representing Impact: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Ensured the KPIs reflect the impact of the project and can be understood within the context of the scope.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'Techniques: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Thought about measuring quantitative KPIs in relative terms rather than absolute to capture the full impact of the project. (e.g. “Through our educational outreach program, we increased scores by 10 points vs. we saw scores improve by 150%”).',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Track current data points: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Discussed the current achievements of the capstone project and consistently tracking data.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Data Tracking and Monitoring:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Discussed strategies for consistently tracking and recording KPI data.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Explored tools like spreadsheets, project management software, or dedicated tracking apps.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Regular Assessment:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Guided the student in scheduling regular assessments of KPI data.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Discussed the importance of analyzing trends, patterns, and deviations.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'DELIVERABLE: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    bold: true,
                },
                {
                    text: '3-5 refined KPIs that are relevant to project objectives, quantifiable, and represent impact: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 2,
            children: [
                {
                    text: 'X',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'X',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'decimal',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'X',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 8: Resource Gathering': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Plan and identify the most necessary and useful resources ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Identify partnerships for capstone project' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [{ text: 'Develop effective strategies for recruiting team members and networking' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Emphasized the ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'significance of resource gathering ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: "for the success of the capstone project. Explained that securing partnerships, recruiting team members, and networking are essential steps in ensuring the project's impact and sustainability.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Illustrated the value of resource gathering:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Leveraging Expertise: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Partnerships bring expertise, mentorship, and additional support to the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Enhanced Collaboration: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'A diverse team contributes varied skills and perspectives to the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Sustainable Impact: ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'Networking and resource connections can lead to long-term project sustainability.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Shared examples ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
                {
                    text: 'of successful resources gathered for other projects or instances where partnerships and networking led to ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    text: 'project growth and success.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Identifying Partnerships:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Research and Outreach',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: "Guided the student in researching potential partners relevant to the project's goals. (Look into leveraging the Crimson network!)",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Discussed effective ways to approach potential partners via emails, Linkedin, networking events, or introductions.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Pitching the Project',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Collaborated on crafting a compelling project pitch for potential partners.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: "Emphasised the project's alignment with partner interests and mutual benefits.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Building Relationships',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Discussed strategies for fostering positive and mutually beneficial partnerships.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Explored ways to maintain open communication and sustain engagement.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Fundraising Resources',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Help the student research and identify potential sources of funding for their project',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Networking for Resources:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Identifying Resource Needs',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Helped the student identify key resources required for project execution (e.g., guest speakers, collaborations with NGOs).',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Discussed how networking can help access these resources.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Connecting with Experts',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'Explored ways to connect with experts or individuals who can contribute to the project.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            listStart: 2,
            children: [
                {
                    text: 'Discussed techniques for initiating conversations and building relationships.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 9: Scaling': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Develop strategies to scale capstone project and amplify impact ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [{ text: 'Choosing the right scaling strategy ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [{ text: 'Addressing challenges and risks ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [{ text: 'Creating a scaling plan ' }],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [{ text: 'Ensuring sustainability ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Create a scaling plan ' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Introduction:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: "Discussed the concept of scaling in the context of the capstone project. Explained that scaling involves expanding the project's scope, reach, and impact to make a larger difference in the community.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            children: [
                {
                    text: 'Practical Application:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                    underline: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Understanding the need for scaling',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Discussed the project’s achievements and impact so far: this should be highly quantifiable',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Identified areas where the project has the potential for greater impact',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Choosing the right scaling strategy',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Discussed different strategies for scaling a project and discuss their applicability to the student’s capstone project',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Discussed vertical scaling (deepening impact within the same community) and horizontal scaling (expanding to new communities or regions).',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Explored partnerships, collaborations, technology integration, and community engagement as potential scaling strategies.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: "Helped the student choose a strategy that aligns with their project's goals, resources, and capabilities.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 3,
            children: [
                {
                    text: 'Addressing challenges and risks',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Discussed common challenges such as resource constraints, community engagement, logistics, and sustainability.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Brainstormed strategies to mitigate these challenges and develop contingency plans.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Encouraged the student to think critically about how to adapt their project to different contexts.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 4,
            children: [
                {
                    text: 'Creating a scaling plan',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Broke down the scaling process into actionable steps.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Assigned responsibilities and set deadlines for each step.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: "Discussed how to measure progress and track the project's impact during scaling.",
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 5,
            children: [
                {
                    text: 'Ensuring sustainability',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            children: [
                {
                    text: 'Discussed strategies for securing ongoing funding, community support, and volunteer engagement.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Explored ways to establish a strong organizational structure and leadership team.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'circle',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Emphasized the importance of continuous evaluation and adaptation to maintain project effectiveness.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            indent: 1,
            children: [
                {
                    text: 'Lesson Deliverable: Scaling Plan (fill in)',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            children: [
                {
                    text: 'Timeline',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 2,
            children: [
                {
                    text: 'Tasks & person responsible',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 3,
            children: [
                {
                    text: 'Scaling strategy overview',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 4,
            children: [
                {
                    text: 'How to measure progress',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 2,
            listStart: 5,
            children: [
                {
                    text: 'Look into the future at the impact of your capstone project. What did you tangibly achieve? Write 150 characters (mirroring the common application form for your activities list). You can refer back to this as you scale your project to keep your goal in mind! Hopefully these 150 characters end up being your actual capstone description.',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'square',
            indent: 3,
            children: [
                {
                    text: 'INSERT HERE',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
    'Module 10: Reflection and Insight': [
        {
            type: 'p',
            children: [
                {
                    text: 'AGENDA:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [{ text: 'Complete and upload the completed capstone form ' }],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [{ text: 'Reflect on project and future plans  ' }],
        },
        { type: 'p', children: [{ text: '' }] },
        {
            type: 'p',
            children: [
                {
                    text: 'NOTES:',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(205, 75, 83)',
                    underline: true,
                    bold: true,
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            children: [
                {
                    text: 'Completed the Capstone ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
                {
                    type: 'a',
                    url: 'https://docs.google.com/document/d/1dWottgY02PNmCHnI_8iuK1OiXTwZnEW_DWoIsM9Aweg/edit#heading=h.n9qcv9k6gffh',
                    target: '_blank',
                    children: [
                        {
                            text: 'Reflection and Insight Form',
                            fontSize: '11pt',
                            backgroundColor: 'transparent',
                            color: 'rgb(17, 85, 204)',
                            underline: true,
                        },
                    ],
                },
            ],
        },
        {
            type: 'p',
            listStyleType: 'disc',
            indent: 1,
            listStart: 2,
            children: [
                {
                    text: 'Discussed next steps for Capstone Project ',
                    fontSize: '11pt',
                    backgroundColor: 'transparent',
                    color: 'rgb(0, 0, 0)',
                },
            ],
        },
    ],
};
//# sourceMappingURL=ecl.js.map